/*
 * Назначение: API раздела «Безопасность» админки.
 * Функционал: настройки защиты от перебора и подтверждения входа, журнал
 * попыток входа, доверенные устройства, включение подтверждения себе.
 * Значения настроек — данные с сервера, в коде их нет.
 */

import { api } from "./api";

export interface SecuritySettings {
  /** Неудач по логину до паузы. */
  login_max_failures: number;
  /** Неудач с одного адреса до паузы. */
  ip_max_failures: number;
  /** За какое время считаем неудачи, мин. */
  window_minutes: number;
  /** Базовая пауза после превышения порога, мин. */
  block_minutes: number;
  /** Сколько дней хранить журнал входов; старое удаляется ночью. */
  attempts_retention_days: number;
  notify_on_attack: boolean;
  notify_on_new_ip: boolean;
  /** Куда писать тревоги и коды; пусто — адрес из настроек почты. */
  security_email: string;
  /** Общий выключатель подтверждения входа кодом. */
  twofa_enabled: boolean;
  code_length: number;
  code_ttl_minutes: number;
  code_max_attempts: number;
  code_resend_seconds: number;
  /** Сколько дней помнить устройство; 0 — спрашивать код каждый раз. */
  trusted_device_days: number;
}

export interface LoginAttempt {
  login: string;
  ip: string | null;
  user_agent: string | null;
  success: boolean;
  reason: string | null;
  created_at: string;
}

export interface TrustedDevice {
  id: string;
  label: string | null;
  ip: string | null;
  last_used_at: string | null;
  expires_at: string;
}

export const securityApi = {
  getSettings: () => api.get<SecuritySettings>("/api/admin/security/settings"),
  updateSettings: (payload: Partial<SecuritySettings>) =>
    api.put<SecuritySettings>("/api/admin/security/settings", payload),
  attempts: (hours = 48, limit = 100) =>
    api.get<LoginAttempt[]>(
      `/api/admin/security/attempts?hours=${hours}&limit=${limit}`,
    ),
  devices: () => api.get<TrustedDevice[]>("/api/admin/security/devices"),
  revokeDevice: (id: string) =>
    api.delete<{ status: string }>(`/api/admin/security/devices/${id}`),
  toggleTwofa: (enabled: boolean) =>
    api.post<{ status: string; enabled: boolean }>("/api/admin/security/twofa", {
      enabled,
    }),
};
